import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconCaretRight12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconCaretRight12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.321 1.204a.5.5 0 0 1 .707 0l4.444 4.444.353.353-.353.354-4.442 4.442a.5.5 0 1 1-.707-.708L7.41 6.001l-4.09-4.09a.5.5 0 0 1 0-.707"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconCaretRight12);
